module.exports = __webpack_public_path__ + "static/media/erp-business-9.5508b746.png";